import { render, staticRenderFns } from "./itemtype_form.vue?vue&type=template&id=718794c9&scoped=true&"
import script from "./itemtype_form.vue?vue&type=script&lang=js&"
export * from "./itemtype_form.vue?vue&type=script&lang=js&"
import style0 from "./itemtype_form.vue?vue&type=style&index=0&id=718794c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718794c9",
  null
  
)

export default component.exports